import { Link } from 'react-router-dom';
import { usePrivacyNotice } from '../hooks/usePrivacyNotice';
import { readerLocale } from '../i18n/language';
import NoticeBody from '../components/NoticeBody';
import { colors } from '../styles/theme';

/**
 * The privacy notice in force, public (#289). While the text is a placeholder a DRAFT banner says
 * so; counsel's text is a new version published from the console, in English and Spanish, with no
 * change to this page.
 */
export default function PrivacyNotice(): JSX.Element {
  const { notice, unavailable } = usePrivacyNotice();

  return (
    <div className="min-h-screen p-6" style={{ background: colors.canvas }}>
      <main
        className="mx-auto max-w-2xl rounded-2xl p-8"
        style={{ background: colors.surface, border: `1px solid ${colors.border}` }}
      >
        <h1 className="text-2xl font-bold mb-3" style={{ color: colors.ink }}>
          Privacy notice
        </h1>
        <NoticeBody notice={notice} unavailable={unavailable} />
        {notice && (
          <p className="mt-4 text-xs" style={{ color: colors.muted }}>
            {`Version ${notice.version} · ${new Date(notice.published_at).toLocaleDateString(readerLocale())}`}
          </p>
        )}
        <p className="mt-6 text-sm">
          <Link to="/login" className="underline" style={{ color: colors.navy }}>
            Back to sign in
          </Link>
        </p>
      </main>
    </div>
  );
}
